// Field option lists mirrored 1:1 from the mobile sell flow.
// Source of truth: AutoPlace-Mobile/lib/services/vehiclesAPI.ts and
// AutoPlace-Mobile/app/(tabs)/sell.tsx.

export const CAR_COLORS = [
  { value: 'Black', label: 'Black' },
  { value: 'White', label: 'White' },
  { value: 'Silver', label: 'Silver' },
  { value: 'Gray', label: 'Gray' },
  { value: 'Beige', label: 'Beige' },
  { value: 'Brown', label: 'Brown' },
  { value: 'Red', label: 'Red' },
  { value: 'Orange', label: 'Orange' },
  { value: 'Yellow', label: 'Yellow' },
  { value: 'Blue', label: 'Blue' },
  { value: 'Green', label: 'Green' },
  { value: 'Gold', label: 'Gold' },
  { value: 'Purple', label: 'Purple' },
  { value: 'Chrome', label: 'Chrome' },
  { value: 'Other', label: 'Other' },
];

export const FUEL_TYPES = [
  { value: 'Gasoline', label: 'Gasoline' },
  { value: 'Diesel', label: 'Diesel' },
  { value: 'Electric', label: 'Electric' },
  { value: 'Hybrid', label: 'Hybrid' },
  { value: 'Plug-in Hybrid', label: 'Plug-in Hybrid' },
];

export const TRANSMISSIONS = [
  { value: 'Manual', label: 'Manual' },
  { value: 'Automatic', label: 'Automatic' },
  { value: 'Semi-Automatic', label: 'Semi-Automatic' },
];

export const BODY_TYPES = [
  { value: 'Sedan', label: 'Sedan' },
  { value: 'SUV', label: 'SUV' },
  { value: 'Hatchback', label: 'Hatchback' },
  { value: 'Coupe', label: 'Coupe' },
  { value: 'Wagon', label: 'Wagon' },
  { value: 'Van', label: 'Van' },
  { value: 'Pickup', label: 'Pickup' },
  { value: 'Convertible', label: 'Convertible' },
  { value: 'Minivan', label: 'Minivan' },
];

export const CONDITIONS = [
  { value: 'NEW', label: 'New' },
  { value: 'USED', label: 'Used' },
  { value: 'CERTIFIED_PRE_OWNED', label: 'Certified Pre-Owned' },
];

export const COMMON_FEATURES = [
  'Air Conditioning',
  'Heated Seats',
  'Leather Seats',
  'Navigation System',
  'Sunroof',
  'Parking Sensors',
  'Backup Camera',
  'Bluetooth',
  'Cruise Control',
  'Keyless Entry',
  'Power Windows',
  'ABS',
  'Airbags',
  'Alarm System',
  'Alloy Wheels',
  'Electric Mirrors',
  'Fog Lights',
  'Traction Control',
  'USB Port',
  'Apple CarPlay',
  'Android Auto',
  'Lane Assist',
  'Blind Spot Monitor',
  'Adaptive Cruise Control',
];

export const COMMON_FEATURE_OPTIONS = COMMON_FEATURES.map((f) => ({
  value: f,
  label: f,
}));

export const IMPORT_AVAILABILITY_OPTIONS = [
  { value: 'AVAILABLE_NOW', label: 'Available Now (at showroom)' },
  { value: 'READY_TO_IMPORT', label: 'Ready to Import' },
] as const;

export const IMPORT_COUNTRIES = [
  'Afghanistan','Albania','Algeria','Andorra','Angola','Antigua and Barbuda','Argentina','Armenia','Australia','Austria','Azerbaijan','Bahamas','Bahrain','Bangladesh','Barbados','Belarus','Belgium','Belize','Benin','Bhutan','Bolivia','Bosnia and Herzegovina','Botswana','Brazil','Brunei','Bulgaria','Burkina Faso','Burundi','Cabo Verde','Cambodia','Cameroon','Canada','Central African Republic','Chad','Chile','China','Colombia','Comoros','Congo','Costa Rica',"Côte d'Ivoire",'Croatia','Cuba','Cyprus','Czech Republic','Democratic Republic of the Congo','Denmark','Djibouti','Dominica','Dominican Republic','Ecuador','Egypt','El Salvador','Equatorial Guinea','Eritrea','Estonia','Eswatini','Ethiopia','Fiji','Finland','France','Gabon','Gambia','Georgia','Germany','Ghana','Greece','Grenada','Guatemala','Guinea','Guinea-Bissau','Guyana','Haiti','Holy See','Honduras','Hungary','Iceland','India','Indonesia','Iran','Iraq','Ireland','Italy','Jamaica','Japan','Jordan','Kazakhstan','Kenya','Kiribati','Kuwait','Kyrgyzstan','Laos','Latvia','Lebanon','Lesotho','Liberia','Libya','Liechtenstein','Lithuania','Luxembourg','Madagascar','Malawi','Malaysia','Maldives','Mali','Malta','Marshall Islands','Mauritania','Mauritius','Mexico','Micronesia','Moldova','Monaco','Mongolia','Montenegro','Morocco','Mozambique','Myanmar','Namibia','Nauru','Nepal','Netherlands','New Zealand','Nicaragua','Niger','Nigeria','North Korea','North Macedonia','Norway','Oman','Pakistan','Palau','Palestine','Panama','Papua New Guinea','Paraguay','Peru','Philippines','Poland','Portugal','Qatar','Romania','Russia','Rwanda','Saint Kitts and Nevis','Saint Lucia','Saint Vincent and the Grenadines','Samoa','San Marino','Sao Tome and Principe','Saudi Arabia','Senegal','Serbia','Seychelles','Sierra Leone','Singapore','Slovakia','Slovenia','Solomon Islands','Somalia','South Africa','South Korea','South Sudan','Spain','Sri Lanka','Sudan','Suriname','Sweden','Switzerland','Syria','Tajikistan','Tanzania','Thailand','Timor-Leste','Togo','Tonga','Trinidad and Tobago','Tunisia','Türkiye','Turkmenistan','Tuvalu','Uganda','Ukraine','United Arab Emirates','United Kingdom','United States','Uruguay','Uzbekistan','Vanuatu','Venezuela','Vietnam','Yemen','Zambia','Zimbabwe',
] as const;
export type ImportCountry = (typeof IMPORT_COUNTRIES)[number];

export const IMPORT_COUNTRY_OPTIONS = IMPORT_COUNTRIES.map((c) => ({
  value: c,
  label: c,
}));

const CURRENT_YEAR = new Date().getFullYear();
export const YEAR_OPTIONS = Array.from(
  { length: CURRENT_YEAR + 1 - 1990 + 1 },
  (_, i) => {
    const y = CURRENT_YEAR + 1 - i;
    return { value: y.toString(), label: y.toString() };
  }
);
